module.exports = __webpack_public_path__ + "media/images/youtube-6c41f07497feafc61b4b684be636c0a6.png";